import React from 'react';
import cx from 'classnames';
import './chart-card.css';

const ChartCard = (props) => {
  const { title, children, titleSmall, className } = props;

  return (
    <>
      {title && (
        <h3 className={`block-header ${titleSmall ? 'title-small' : ''}`}>{title}</h3>
      )}
      <div className={cx('chart-card-container', className)}>{children}</div>
    </>
  );
};

ChartCard.propTypes = {};

ChartCard.defaultProps = {
  className: '',
};

export default ChartCard;
